// React core and hooks
import React, { useState } from 'react'
// Firebase Imports
import { auth, db } from '../firebase'
import { addDoc, collection, serverTimestamp, updateDoc, doc } from 'firebase/firestore'
// MUI Components and Icons
import { Container, Box, TextField, InputAdornment, IconButton, useTheme, useMediaQuery, Grid, Typography } from '@mui/material'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
// Custom components
import DialogSlide from '../components/DialogSlide'
import BasicModal from '../components/modals/BasicModal'
import ChatsList from '../components/ChatsList'
import MessagesList from '../components/MessagesList'

const URL = 'https://somalia-question-688160029673.europe-west10.run.app'
function ChatPage () {
  // Themeing
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTabletorMobile = useMediaQuery(theme.breakpoints.down('md'))
  const pageStyle = {
    content: { height: isMobile ? 'calc(100vh - 56px)' : 'calc(100vh - 84px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    messagesContainer: { maxWidth: '820px', m: 'auto', height: '90%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', flexGrow: 1, flexShrink: 1, overflow: 'auto' },
    sidebarContainer: { marginTop: '2px', backgroundColor: '#F7F9F9', display: isTabletorMobile ? 'none' : 'flex', flexDirection: 'column', height: 'calc(100vh - 84px)' },
    newsFeedList: { overflow: 'auto' },
    messageList: { m: '0px 3px 0px 3px', overflow: 'auto' },
    inputContainer: { maxWidth: '820px', width: '100%', m: 'auto', display: 'flex', alignItems: 'center', flexGrow: 0, flexShrink: 0, mt: 1 },
    textField: { mr: '5px', mb: '5px' }
  }
  // State
  const [newMessage, setNewMessage] = useState('')
  const [lastMessage, setLastMessage] = useState('')
  const [selectedChatId, setSelectedChatId] = useState(localStorage.getItem('selectedChatId'))
  const [isSlideOpen, setSlideOpen] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const [isFailed, setIsFailed] = useState(false)
  const [isLocked, setIsLocked] = useState(false)

  const handleSelectChat = (chatId) => {
    localStorage.setItem('selectedChatId', chatId)
    setSelectedChatId(chatId)
    setSlideOpen(false)
  }

  const processMessageToAPI = async (url, chatMessage, userId, chatId) => {
    try {
      const apiRequestBody = {
        content: chatMessage,
        userId,
        chatId
      }

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(apiRequestBody)
      })
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      // assumes i get something back
      const data = await response.json()
      setIsTyping(false)

      return data
    } catch (error) {
      console.error('Error in processMessageToAPI: ', error)
      setIsFailed(true)
    }
  }

  const handleSendMessage = async () => {
    if (!newMessage.trim()) return
    try {
      setIsTyping(true)
      const userId = auth.currentUser.uid
      let chatId = selectedChatId
      const message = newMessage.trim()
      // If no chat is selected, create a new one
      if (!chatId) {
        const newChatDoc = await addDoc(collection(db, `users/${auth.currentUser.uid}/chats`), {
          label: message.slice(0, 35),
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        })
        chatId = newChatDoc.id
        localStorage.setItem('selectedChatId', chatId)
        setSelectedChatId(chatId)
      }

      // removes Message from Input Field
      setLastMessage(message)
      setNewMessage('')

      const APIresponse = await processMessageToAPI(URL, message, userId, chatId, setIsFailed)

      // only writes to DB if APICall suceeds
      if (APIresponse) {
        // save Usermessage
        await addDoc(collection(db, `users/${userId}/chats/${chatId}/messages`), {
          content: message,
          createdAt: serverTimestamp(),
          role: 'user'
        })
        // save APIResonse
        await addDoc(collection(db, `users/${userId}/chats/${chatId}/messages`), {
          content: APIresponse.ai_msg,
          createdAt: serverTimestamp(),
          role: 'assistent'
        })

        // update Chat Document
        await updateDoc(doc(db, `users/${userId}/chats/${chatId}`), {
          updatedAt: serverTimestamp()
        })
      }
    } catch (err) {
      console.error(err)
    } finally {
      setIsTyping(false)
    }
  }

  const resendRequest = async () => {
    setIsFailed(false)
    try {
      setIsTyping(true)
      const userId = auth.currentUser.uid
      const chatId = selectedChatId
      const message = lastMessage

      const APIresponse = await processMessageToAPI(URL, message, userId, chatId, setIsFailed)
      // save APIResonse
      await addDoc(collection(db, `users/${userId}/chats/${chatId}/messages`), {
        content: APIresponse.ai_msg,
        createdAt: serverTimestamp(),
        role: 'assistent'
      })

      // update Chat Document
      await updateDoc(doc(db, `users/${userId}/chats/${chatId}`), {
        updatedAt: serverTimestamp()
      })
    } catch (err) {
      console.error(err)
    } finally {
      setIsTyping(false)
    }
  }

  return (
    <Grid container>
      <Grid item md={4} sx={ pageStyle.sidebarContainer}>
        <ChatsList onSelectChat={handleSelectChat} chatId={selectedChatId}></ChatsList>
      </Grid>
      <Grid item xs={12} md={8} >
          {isTabletorMobile &&
          <DialogSlide open={isSlideOpen} setOpen={setSlideOpen}>
            <ChatsList onSelectChat={handleSelectChat} chatId={selectedChatId}></ChatsList>
          </DialogSlide>}
      <Container sx={ pageStyle.content }>
          <Box sx={ pageStyle.messagesContainer }>
              <MessagesList chatId={selectedChatId} isTyping={isTyping} isFailed={isFailed} resendRequest={() => { resendRequest() }} lastMessage={{ content: lastMessage, role: 'user' }}/>
          </Box>
          <Box sx={ pageStyle.inputContainer }>
              <TextField
              fullWidth
              variant="outlined"
              label={'Message the P4P-Copilot'}
              value={newMessage}
              disabled={isTyping}
              onChange={(e) => { setNewMessage(e.target.value) }}
              multiline
              maxRows={3}
              InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end" disabled={isTyping} onClick={() => { handleSendMessage() }}>
                        <ArrowUpwardIcon />
                      </IconButton>
                    </InputAdornment>
                )
              }}
              sx={pageStyle.textField}
              />
          </Box>
      </Container>
      </Grid>
    <BasicModal isOpen={isLocked} title={'Game Paused'} handleClose={() => { setIsLocked(false) }} >
      <Box sx={{ mb: '10px' }}>
        <Typography variant='body' sx={{ mb: 3, whiteSpace: 'pre-wrap' }}>
            Hier könnte ihre Werbung stehen.
        </Typography>
      </Box>
    </BasicModal>
    </Grid>
  )
}

export default ChatPage
